import {apiUrl} from '../utils/constants';
import {DELETE} from './api.service.wrapper';

export const DeleteProdcutComparision = async (id) => {
    const response = await DELETE(apiUrl.product_comparisons, id);
    return response;
}

